import { Component, EventEmitter, OnInit, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatSidenav } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { CustomEventCommand, CustomPlaceCommand } from '../../../commands/hub/custom.event.command';
import {
  CustomDefaultPlaceCategory,
  VisitorCalendarActionCommand,
  VisitorStyleCommand,
} from '../../../commands/pagination.query.command';
import { AllFrontendSettingsCommand } from '../../../commands/visitor/all.frontend.settings.command';
import { BaseComponent } from '../../../common/components/base.component';
import { PlaceCategory } from '../../../common/constants/constant';
import { getRouteUrl, routeConfigs } from '../../../common/constants/route.config';
import { HubVisitorFeatureToggle, HubVisitorToggleDataSource } from '../../../models/hub/hub.visitor.feature.toggle';
import { HubVisitorPromotionImage } from '../../../models/hub/hub.visitor.promotion.image';
import { ImageService } from '../../../services/image.service';
import { PlaceService } from '../../../services/place.service';
import { VisitorApiService } from '../../../services/visitor.api.service';
import {
  AllFrontendSettingsStore,
  VisitorCalendarStore,
  VisitorStyleStore,
} from '../../../stores/visitor.calendar.store';
import { FacebookLoginButtonComponent } from '../../../common/components/facebook.login.button/facebook.login.button.component';
import { config } from '../../../../config/config';
import AuthResponse = facebook.AuthResponse;
import { ModalService } from '../../../common/services/modal.service';
import { DomSanitizer } from '@angular/platform-browser';
import { VisitorComponent } from '../visitor.component';
import { EditorChoiceDataSource } from '../../../models/hub/hub.event';
import { CustomDefaultPlaceCategoryItemSelectionStore, EditorChoiceStore } from '../../../stores/hub.calendar.store';
import { AccordionComponent } from '../../../common/components/accordion/accordion.component';
import { PlaceType } from '../../hub/place.category/customize.place.category.component';
import { CustomDefaultPlaceCategoryAccordionComponent } from '../../hub/custom.default.place.category.accordion/custom.default.place.category.accordion.component.';
import { EventFilterComponent } from '../event.filter/event.filter.component';
import { CustomPlaceBtnComponent } from '../custom.place.btn/custom.place.btn.component';
import { localStorageKeys } from '../../../common/constants/local.storage.keys';

@Component({
  selector: 'ig-side-bar',
  templateUrl: './visitor.side.bar.component.html',
  styleUrls: ['./visitor.side.bar.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class VisitorSideBarComponent extends BaseComponent implements OnInit {
  public hubName: string;
  public simpleMenu = true;
  public isHideEditorChoice: boolean;
  public authResponse: AuthResponse;
  public searchText: string;
  public searchFormGroup: FormGroup;
  public dateFormGroup: FormGroup;
  public from: Date;
  public to: Date;
  public today = new Date();
  public category: string;
  public categoryId: string;
  public menuType: string;
  public command = new VisitorCalendarActionCommand();
  public selectedCustomEvent = new CustomEventCommand();
  public selectedCustomPlace = null;
  public dateFilterType: string;
  public visitorPromotionImage = new HubVisitorPromotionImage();
  public eventPositionImage = config.eventPositionImage;
  public customDefaultPlaceCategory: CustomDefaultPlaceCategory = null;
  public searchParam = {
    searchTimeout: null,
    debounceTime: 500,
    isSearching: false,
  };
  public featuresToggle = new HubVisitorFeatureToggle();
  public toggleAndSource = new HubVisitorToggleDataSource();
  public loadingToggles = true;
  @ViewChild('loginWithFBBtn') loginWithFBBtn: FacebookLoginButtonComponent;
  @Output() onClose: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild('sideBar') sideBar: MatSidenav;
  @ViewChild('eventFilter') public eventFilter: EventFilterComponent;
  @ViewChild('customEventAccordion') public customEventAccordion: AccordionComponent;
  @ViewChild('eventDateAccordion') public eventDateAccordion: AccordionComponent;
  @ViewChild('placeCategoryAccordion') public placeCategoryAccordion: CustomDefaultPlaceCategoryAccordionComponent;
  @ViewChild('customPlaceBtn') public customPlaceBtn: CustomPlaceBtnComponent;
  //public customEvents: CustomEvent[];
  public customEvents: CustomEventCommand[];
  public customPlaces: CustomPlaceCommand[];
  public editorChoiceText = '';
  public selectedEvents = null;
  public isEditorChoice: boolean | null = null;
  public initialCustomDefaultPlaceCategory: {
    categoryList: string[];
    categoryString: string;
    category: PlaceType;
  };

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private visitorCalendarStore: VisitorCalendarStore,
    private customDefaultPlaceCategoryItemSelectionStore: CustomDefaultPlaceCategoryItemSelectionStore,
    private formBuilder: FormBuilder,
    private visitorApiService: VisitorApiService,
    private parent: VisitorComponent,
    private editorChoiceStore: EditorChoiceStore,
    private visitorStyleStore: VisitorStyleStore,
    private allFrontendSettingsStore: AllFrontendSettingsStore,
    private domSanitizer: DomSanitizer,
    private imageService: ImageService,
    private modalService: ModalService
  ) {
    super({ activatedRoute });
  }

  public ngOnInit() {
    let { hubName, category, menuType } = this.allRouteParams;
    this.hubName = hubName;
    this.eventPositionImage = this.imageService.imageSourceUrl(this.eventPositionImage);
    this.setMenuType(menuType, category);
    this.visitorCalendarStore.actionCommand.next(this.command);

    this.visitorCalendarStore.actionCommand
      .takeUntil(this.isDestroyed)
      .subscribe((command: VisitorCalendarActionCommand) => {
        this.command = command;
        console.log('command in sidebar', this.command);
        this.setSelectedDefaultCategoryFilterBackFromMapView();
        this.setQueryCommand(menuType, category);

        // get the selected category back from map view
        if (this.command.queryCommand.category && this.menuType !== 'custom') {
          this.category = this.command.queryCommand.category;
          console.log('this.category in sidebar command', this.category);
        }
        // custom place btn selected, back from map view
        if (this.command.queryCommand.customPlaceBtnText) {
          this.customPlaceBtn &&
            this.customPlaceBtn.setFilter(
              this.command.queryCommand.customPlaceBtnText,
              this.command.queryCommand.choice
            );
        }
      });

    this.searchFormGroup = this.formBuilder.group({
      searchText: [null],
    });

    this.dateFormGroup = this.formBuilder.group({
      from: [null, [Validators.required]],
      to: [null, [Validators.required]],
    });

    this.loadSettings();
    this.editorChoiceTextHandler();
  }

  public loadSettings() {
    this.loadingToggles = true;
    this.allFrontendSettingsStore.allFrontendSettingsCommand
      .takeUntil(this.isDestroyed)
      .subscribe((command: AllFrontendSettingsCommand) => {
        if (command.customSettings) {
          this.customEvents = command.customSettings.customEvents || null;
          this.customPlaces = command.customSettings.customPlaces || null;
          this.isHideEditorChoice = command.customSettings.isHideEditorChoice || false;
          this.visitorPromotionImage = command.customSettings.visitorPromotion || null;

          if (command.customSettings.logo && !command.customSettings.logo.isDefault) {
            this.eventPositionImage = this.imageService.imageSourceUrl(command.customSettings.logo.url);
          }
          this.setCustomDefaultPlaceCategory(command.customSettings.customDefaultPlaceCategory);
        }
        if (command.toggle) {
          this.featuresToggle = command.toggle;
          if (this.isAllPlaceCategoriesTurnedOff) {
            this.featuresToggle.placeCalendar = false;
          }
          this.loadingToggles = false;

          this.toggleAndSource.toggle = this.featuresToggle;
          this.toggleAndSource.dataSource = command.dataSource;

          if (!this.command.isEventCalendar) {
            this.command.queryCommand.category = this.category;
            this.command.queryCommand.source = this.toggleAndSource.dataSource.place;
          }
        }
      });
  }

  public setQueryCommand(menuType: string, category: string) {
    !!this.activatedRoute.firstChild &&
      this.activatedRoute.firstChild.url.subscribe((x) => {
        // this.command.isEventCalendar = (x[0].path === routeConfigs.visitor.eventCalendar.path || routeConfigs.visitor.eventDetailsModal.path.indexOf(x[0].path) >= 0);
        if (
          x[0].path === routeConfigs.visitor.eventCalendar.path ||
          x[0].path === routeConfigs.visitor.editorChoice.path ||
          routeConfigs.visitor.customEvent.path.indexOf(x[0].path) >= 0 ||
          routeConfigs.visitor.eventDetailsModal.path.indexOf(x[0].path) >= 0
        ) {
          this.command.isEventCalendar = true;
        } else {
          this.command.isEventCalendar = false;
        }

        if (
          x[0].path === routeConfigs.visitor.editorChoice.path ||
          x[0].path === routeConfigs.visitor.placeEditorChoice.path
        ) {
          this.command.queryCommand.choice = true;
        }
        // else {
        //     this.command.queryCommand.choice = false;
        // }
      });
  }

  public setMenuType(menuType: string, category: string) {
    this.menuType = menuType || null;
    if (this.menuType === 'custom') {
      this.categoryId = category;
    } else {
      this.category = category || 'All';
    }
    this.simpleMenu = menuType === 'simple' && !this.command.isEventCalendar;
    this.command.queryCommand.category = category;
  }

  public editorChoiceTextHandler() {
    this.editorChoiceStore.infoCommand.takeUntil(this.isDestroyed).subscribe((editorChoice: EditorChoiceDataSource) => {
      if (!!this.command.isEventCalendar) {
        this.editorChoiceText = editorChoice.editorChoiceForEvent;
      } else {
        this.editorChoiceText = editorChoice.editorChoiceForPlace;
      }
    });
  }

  private setSelectedDefaultCategoryFilterBackFromMapView() {
    // get the selected category back from map view
    if (this.command.queryCommand.category) {
      if (this.menuType !== 'custom') {
        this.category = this.command.queryCommand.category;
        this.setCustomDefaultPlaceFilter(this.category);
      } else {
        setTimeout(() => {
          try {
            const str = localStorage.getItem(localStorageKeys.selectedPlaceCategory);
            const data = str ? JSON.parse(str) : { title: this.command.queryCommand.category };
            if (data) {
              this.setCustomDefaultPlaceFilter(data.title);
            }
          } catch (error) {
            console.log('Not parse selectedPlaceCategory', error.message);
          }
        }, 1600);
      }
    }
  }

  private setCustomDefaultPlaceFilter(title) {
    title = title || '';
    title = title.toLowerCase() === 'all' ? '' : title;
    this.placeCategoryAccordion && this.placeCategoryAccordion.setFilter(title);
  }

  /**
   * if visit a custom default place category url, e.g., http://localhost:4200/test4/places/62a46ea3e6ad6016f05245ff/custom
   * */
  private setCustomDefaultPlaceCategory(customDefaultPlaceCategory) {
    // if (localStorage.getItem(localStorageKeys.selectedPlaceCategory)) return;

    if (this.menuType === 'custom') {
      // this.category is the custom default place category id, e.g., 62a46ea3e6ad6016f05245ff
      const data = PlaceService.getCustomDefaultCategoryFromURL(this.categoryId, customDefaultPlaceCategory);
      if (data) {
        // this.categoryId = this.category;
        this.category = data.category.title;
        // this.customDefaultPlaceCategory = data.customDefaultPlaceCategory;
        this.customDefaultPlaceCategory = customDefaultPlaceCategory;
        this.command.queryCommand.categoryList = data.categoryList;
        const categoryString = JSON.stringify(data.category);
        this.initialCustomDefaultPlaceCategory = {
          category: data.category,
          categoryString: categoryString,
          categoryList: data.categoryList,
        };
        // for map view
        const storage = localStorage.getItem(localStorageKeys.selectedPlaceCategory);
        if (!storage) {
          localStorage.setItem(localStorageKeys.selectedPlaceCategory, categoryString);
        }
      }
    } else {
      this.customDefaultPlaceCategory = customDefaultPlaceCategory;
    }
    // this.visitorCalendarStore.actionCommand.next(this.command);
  }

  public get isShowThingsToDo() {
    return (
      !this.loadingToggles &&
      (this.featuresToggle.placeCategory.activity ||
        this.featuresToggle.placeCategory.art ||
        this.featuresToggle.placeCategory.outdoor ||
        this.featuresToggle.placeCategory.entertainment)
    );
  }

  private get isAllPlaceCategoriesTurnedOff() {
    return PlaceService.isAllCategoriesTurnedOff(this.featuresToggle.placeCategory);
  }

  public get isEventEnabled() {
    return this.featuresToggle.manualEvents || this.featuresToggle.eventByGeolocation;
  }

  public viewChange() {
    this.command.isMapView = !this.command.isMapView;
    // this.command.isMapView = true;

    let path = { path: '' };
    if (this.command.isMapView) {
      if (this.command.isEventCalendar) {
        path = routeConfigs.visitor.eventMap;
      } else {
        path = routeConfigs.visitor.placeMap;
      }
    } else {
      if (this.command.isEventCalendar) {
        path = routeConfigs.visitor.eventCalendar;
      } else {
        path = routeConfigs.visitor.placeCalendar;
      }
    }
    if (this.command.isEventCalendar) {
      this.router.navigateByUrl(
        getRouteUrl(path, {
          hubName: this.hubName,
        }),
        { skipLocationChange: this.noChangeUrlWhenRedirect }
      );
    } else {
      const cate = this.customDefaultPlaceCategory.useDefault
        ? PlaceCategory.getPlaceCategoryKey(this.category)
        : this.menuType === 'custom'
        ? this.categoryId
        : 'All';
      this.router.navigateByUrl(
        getRouteUrl(path, {
          hubName: this.hubName,
          category: cate,
          menuType: this.menuType || (this.simpleMenu ? 'simple' : 'normal'),
        }),
        { skipLocationChange: this.noChangeUrlWhenRedirect }
      );
    }

    this.visitorCalendarStore.actionCommand.next(this.command);
    this.close();
  }

  public close() {
    this.onClose.emit();
  }

  public gotoPlaceCalendar() {
    this.searchText = null;
    this.category = 'all';
    let path = this.command.isMapView ? routeConfigs.visitor.placeMap : routeConfigs.visitor.placeCalendar;
    this.command.isEventCalendar = false;
    this.command.queryCommand.category = 'All';
    this.command.queryCommand.from = null;
    this.command.queryCommand.search = null;
    this.command.queryCommand.to = null;
    this.command.queryCommand.choice = null;
    this.command.queryCommand.isCustom = null;
    this.command.queryCommand.selectedEvents = null;
    this.command.queryCommand.feedId = null;
    this.command.queryCommand.mostAttended = null;

    let styleCommand = new VisitorStyleCommand();
    styleCommand.menuStyle.isSideBar = this.parent.allFrontendSettings.customSettings.menuStyle.isSideBar;
    // styleCommand.menuStyle.menuBarMode = this.parent.menuBarMode;
    this.visitorStyleStore.styleCommand.next(styleCommand);

    this.router.navigateByUrl(
      getRouteUrl(path, {
        hubName: this.hubName,
        category: this.category,
      }),
      { skipLocationChange: this.noChangeUrlWhenRedirect }
    );
    this.visitorCalendarStore.actionCommand.next(this.command);
    this.close();
  }

  public gotoTripPlanner() {
    let path = routeConfigs.tripPlanner.trip; //routeConfigs.visitor.trip;
    this.router.navigateByUrl(
      getRouteUrl(path, {
        hubName: this.hubName,
      }),
      { skipLocationChange: this.noChangeUrlWhenRedirect }
    );
    this.close();
  }

  public clearSearchText() {
    this.searchText = null;
    this.search(null);
  }

  public search($event) {
    if ($event && $event.key === 'Tab') {
      return;
    }

    const isKeepFilter = false;

    if (!isKeepFilter) {
      this.eventDateAccordion && this.eventDateAccordion.clearFilter(null, false);
      this.customEventAccordion && this.customEventAccordion.clearFilter(null, false);
      this.selectedEvents = null;
      this.isEditorChoice = null;
      this.from = null;
      this.to = null;
      this.category = null;
      this.eventFilter && this.eventFilter.clearFilter();
    }

    let command = this.command;
    command.queryCommand.search = this.searchText || null;
    command.queryCommand.from = this.from || null;
    command.queryCommand.to = this.to || null;
    command.queryCommand.category = this.category || null;
    command.queryCommand.choice = this.isEditorChoice;
    command.queryCommand.selectedEvents = this.selectedEvents;
    command.queryCommand.categoryList = null;
    command.queryCommand.customEventBtnText = null;
    command.queryCommand.dateFilterText = null;
    command.queryCommand.isCustom = null;
    command.queryCommand.feedId = null;

    if (!this.command.isEventCalendar) {
      command.queryCommand.from = null;
      command.queryCommand.to = null;
    }
    command.isEventCalendar = this.command.isEventCalendar;
    //this.visitorCalendarStore.actionCommand.next(command);
    this.customDefaultPlaceCategoryItemSelectionStore.CustomDefaultPlaceCategoryItemSelectionCommand.next(null);

    if (this.searchParam.searchTimeout) {
      clearTimeout(this.searchParam.searchTimeout);
      this.searchParam.searchTimeout = setTimeout(() => {
        this.searchParam.isSearching = true;
        setTimeout(() => {
          this.searchParam.isSearching = false;
          this.close();
        }, 4000);
        this.visitorCalendarStore.actionCommand.next(command);
      }, this.searchParam.debounceTime);
      return;
    }

    this.searchParam.searchTimeout = setTimeout(() => {
      this.searchParam.isSearching = true;
      setTimeout(() => {
        this.searchParam.isSearching = false;
        this.close();
      }, 4000);
      this.visitorCalendarStore.actionCommand.next(command);
    }, this.searchParam.debounceTime);
  }

  public addEventsManually() {
    this.router.navigateByUrl(
      getRouteUrl(routeConfigs.visitor.createEvent, {
        hubName: this.hubName,
      }),
      { skipLocationChange: this.noChangeUrlWhenRedirect }
    );
    this.close();
  }

  public addPlacesManually() {
    this.router.navigateByUrl(
      getRouteUrl(routeConfigs.visitor.createPlace, {
        hubName: this.hubName,
      }),
      { skipLocationChange: this.noChangeUrlWhenRedirect }
    );
    this.close();
  }

  public isSelected(title: string) {
    return !this.command.queryCommand.choice && !this.selectedCustomPlace && this.category === title;
  }

  public filterPlace(category) {
    this.searchText = null;
    this.category = category;

    let command = new VisitorCalendarActionCommand();
    command.isEventCalendar = false;
    command.queryCommand.choice = null;
    command.queryCommand.search = null;
    this.selectedCustomPlace = null;
    let path = this.command.isMapView ? routeConfigs.visitor.placeMap : routeConfigs.visitor.placeCalendar;

    if (category === 'selected') {
      command.queryCommand.isCustom = true;
      command.queryCommand.category = null;
      this.router.navigateByUrl(
        getRouteUrl(path, {
          hubName: this.hubName,
        }),
        { skipLocationChange: this.noChangeUrlWhenRedirect }
      );
    } else {
      // custom default category from URL, e.g., http://localhost:4200/test4/places/62a46ea3e6ad6016f05245ff/custom
      if (this.menuType === 'custom') {
        // all selected, load all categroyList
        command.queryCommand.categoryList = this.initialCustomDefaultPlaceCategory.categoryList;
        // for map view
        localStorage.setItem(
          localStorageKeys.selectedPlaceCategory,
          this.initialCustomDefaultPlaceCategory.categoryString
        );
      } else {
        this.category = category;
        command.queryCommand.category = category || null;
        this.placeCategoryAccordion && this.placeCategoryAccordion.clearFilter();
        this.customPlaceBtn && this.customPlaceBtn.clearFilter();
      }
      this.router.navigateByUrl(
        getRouteUrl(path, {
          hubName: this.hubName,
          category: this.menuType === 'custom' ? this.categoryId : PlaceCategory.getPlaceCategoryKey(this.category),
          menuType: this.menuType,
        }),
        { skipLocationChange: this.noChangeUrlWhenRedirect }
      );
    }
    command.queryCommand.source = this.toggleAndSource.dataSource.place;
    this.close();
    this.visitorCalendarStore.actionCommand.next(command);

    this.customDefaultPlaceCategoryItemSelectionStore.CustomDefaultPlaceCategoryItemSelectionCommand.next(null);
  }

  public closeSidebar() {
    this.onClose.emit();
  }

  public selectCustomDefaultPlaceCategory($event: PlaceType) {
    this.category = $event.title;
    // in order for calendar to load when currently showing submit place view
    this.router.navigateByUrl(
      getRouteUrl(routeConfigs.visitor.placeCalendar, {
        hubName: this.hubName,
        // category: $event.title,
        category: this.menuType === 'custom' ? this.categoryId : 'All',
        menuType: this.menuType,
      })
    );
    this.command.isEventCalendar = false;
    this.command.queryCommand.feedId = null;
    this.command.queryCommand.category = $event.title;
    this.command.queryCommand.categoryList = $event.categoryList;
    this.command.queryCommand.selectedPlaces = null;
    this.command.queryCommand.isCustom = null;
    this.command.queryCommand.search = '';
    this.visitorCalendarStore.actionCommand.next(this.command);
    this.searchText = '';
    this.command.queryCommand.source = this.toggleAndSource.dataSource.place;
    this.selectedCustomPlace = null;
    this.close();
    $event && this.placeCategoryAccordion && this.placeCategoryAccordion.setFilter($event.title);
    !$event && this.placeCategoryAccordion && this.placeCategoryAccordion.clearFilter();
    this.customPlaceBtn && this.customPlaceBtn.clearFilter();
  }
}



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/visitor/side.bar/visitor.side.bar.component.ts